interface SectionBadgeProps {
  children: React.ReactNode
  className?: string
}

export default function SectionBadge({ children, className = "" }: SectionBadgeProps) {
  return (
    <div className={`font-light inline-flex items-center gap-2 px-4 py-1.5 border bg-background backdrop-blur-sm rounded-full text-sm text-foreground shadow-xs hover:shadow-sm transition-all duration-300 dark:bg-input/30 dark:border-input ${className}`}>
      {children}
    </div>
  )
}
